import {resolveStoreAccess} from '@/utils/access-context';
import {TEMPLATE_FAMILIES, TEMPLATE_PROFILES} from '@/utils/template-profiles';

export function isInternalTemplate(accessContext = {}) {
    return accessContext.template_family === TEMPLATE_FAMILIES.INTERNAL;
}

export function isCustomerTemplate(accessContext = {}) {
    return accessContext.template_family === TEMPLATE_FAMILIES.CUSTOMER;
}

export function isGuestTemplate(accessContext = {}) {
    return accessContext.template_family === TEMPLATE_FAMILIES.GUEST;
}

export function isExternalTemplate(accessContext = {}) {
    return isCustomerTemplate(accessContext) || isGuestTemplate(accessContext);
}

export function resolveAccessState(store) {
    const accessContext = resolveStoreAccess(store);

    return {
        accessContext,
        templateFamily: accessContext.template_family || TEMPLATE_FAMILIES.PUBLIC,
        templateProfile: accessContext.template_profile || TEMPLATE_PROFILES.PUBLIC,
        isAdmin: !!accessContext.is_admin,
        isCustomer: !!accessContext.is_customer,
        isGuest: !!accessContext.is_guest,
        isEmployeeLike: !!accessContext.is_employee_like,
        isServiceProvider: !!accessContext.is_service_provider,
        isInternal: isInternalTemplate(accessContext),
        isExternal: isExternalTemplate(accessContext),
    };
}
